import {
  Card,
  CardBody,
  CardExpandToggler,
} from "./../../../components/card/card.jsx";

import React, { useState, useEffect } from "react";
import { location } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { toast } from "react-toastify";
import { printLocation, renderImage } from "../../../utils/helper";
import LocationCardDetail from "./location-cards-detail";
import { useAuth } from "../../../contexts/AuthContext";

function LocationCards() {
  const { config } = useAuth();
  const [locationList, setLocationList] = useState([]);
  async function getLocation() {
    try {
      const res = await location.list();
      const data = await parserAPI(res);
      //console.log({ config });
      let vehicle = data;
      if (config.overview_level) {
        if (data.length && config?.overview_level == 2) {
          vehicle = data[0].sublocations;
        }
        if (data.length && config?.overview_level == 3) {
          vehicle = data[0].sublocations[0]?.sublocations;
        }
      }
      setLocationList(vehicle);
    } catch (e) {
      toast.error(e.message);
    }
  }
  useEffect(() => {
    getLocation();
  }, []);

  return (
    <>
      {locationList.map((location, index) => {
        return (
          <div className="col-xl-6" key={index}>
            <Card className="mb-3 testing-tour-2">
              <CardBody>
                <div className="d-flex fw-bold small mb-3">
                  <span className="flex-grow-1">
                    {printLocation(location.location_name)}
                  </span>
                  <CardExpandToggler />
                </div>
                <div
                  className="card-fe"
                  style={{
                    backgroundImage: `url(${renderImage(
                      "/machine/attachment/" + location.picture_url
                    )})`,
                  }}
                ></div>
                <LocationCardDetail location_id={location.id} />
              </CardBody>
            </Card>
          </div>
        );
      })}
    </>
  );
}

export default LocationCards;
